// extracted by mini-css-extract-plugin
export default {"wrapper":"error-404__wrapper__a4ABC utils__page__pSVbl"};